let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("JjuBo")).then(() => parcelRequire('5Crrm'));